// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3197":"e8a15dc07be6d341","9217":"0620efdca1760c81"}[chunkId] + ".css";
};